import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgUnlock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4825 38.2017C26.1299 38.4781 23.9657 43.0002 23.5527 45.2267L22.747 57.7478C22.498 62.1453 22 72.2319 22 77.3978C22 83.8552 27.3787 85.9383 29.5452 85.9383C31.7116 85.9383 40.3774 86.6326 41.5727 86.7021C42.7679 86.7715 59.95 86.7021 65.6276 85.9383C70.1697 85.3273 71.4048 81.1936 71.4546 79.2031C71.5791 77.3284 71.8281 73.0512 71.8281 70.9404C71.8281 68.3019 72.2763 53.2345 71.8281 46.1522C71.3799 39.0699 64.507 37.6812 60.9959 37.6812C57.4848 37.6812 53.0025 38.2017 50.089 38.2017C47.1755 38.2017 38.1733 37.8563 31.4825 38.2017Z",
			stroke: "#1B1B20",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.255 37.8267C28.3533 28.6148 30.9647 9.13984 47.7025 9.84532C64.4403 10.5508 64.7227 20.152 64.7227 25.8486H58.499C56.2965 23.3661 57.1366 18.6047 47.7025 18.6047C43.1617 18.6047 38.2584 23.8444 38.2584 37.8267",
			stroke: "#1B1B20",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M26.1071 47.4699C25.866 45.6445 26.479 41.849 30.86 41.2704C36.3361 40.5472 44.912 40.4438 46.6685 40.4438H58.0341C61.8915 40.0994 69.565 41.3324 69.3997 49.0197C69.2343 56.707 69.3308 68.2723 69.3997 73.0941V77.847C69.4685 79.3968 68.6557 82.6412 64.8534 83.2198C60.5153 83.8799 46.02 83.8515 40.9305 83.8415C40.4439 83.8405 40.0433 83.8397 39.7458 83.8397C36.3361 83.8397 28.5868 83.4264 26.8303 81.6699C25.0738 79.9134 24.8672 76.6071 24.8672 74.7473C24.8672 73.5682 25.1164 68.1117 25.2988 64.1173C25.4041 61.8111 25.4871 59.9923 25.4871 59.7653C25.4871 59.2694 25.7627 50.5007 26.1071 47.4699ZM50.3317 48.8606C52.6576 49.9424 57.0983 53.1769 56.2545 57.4609C55.4107 61.7448 52.7657 63.7894 51.5487 64.2762L53.4959 77.5824C53.2796 78.2315 52.4412 79.5296 50.8185 79.5296C49.1958 79.5296 45.2202 79.0428 43.4352 78.7994V70.2802C43.4352 68.7873 43.1648 65.2228 43.0295 63.6272C41.2716 61.9233 37.8044 58.1911 37.9992 56.893C38.2426 55.2703 40.8389 48.6172 44.4088 48.3738C47.2648 48.1791 49.5474 48.6172 50.3317 48.8606Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.0593 34.1782C71.1573 34.317 73.1441 35.5067 73.6189 36.193",
			stroke: "#1B1B20",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.3741 30.062C71.3821 29.5905 73.7002 28.6109 74.9086 28.4651M68.7719 25.8752C69.4366 25.503 70.6002 24.908 70.8887 23.3753",
			stroke: "#1B1B20",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6775 55.4519C38.3916 58.2537 41.7033 61.7656 43.3949 63.1713C43.109 67.1501 42.5515 75.4651 42.6087 76.8946C42.6659 78.3241 43.9191 79.2056 44.5385 79.4677C46.2301 79.6345 49.9992 79.868 51.5431 79.4677C53.087 79.0674 53.2823 77.5855 53.187 76.8946C52.5199 72.4393 51.2572 63.5287 51.5431 63.5287C51.9005 63.5287 55.5457 63.5287 55.9746 56.1667C56.4034 48.8047 48.6841 48.3044 45.968 48.2329C43.252 48.1615 39.0349 51.9497 38.6775 55.4519Z",
			stroke: "#1B1B20",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.7188 43.9829C64.4897 44.2056 66.0008 45.566 65.8774 49.2253",
			stroke: "#1B1B20",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.9289 52.6689L65.6719 54.1594",
			stroke: "#1B1B20",
			strokeWidth: 3,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.4456 60.4552C53.9711 55.7323 52.3759 52.2775 51.4613 50.5314C49.2994 48.9793 44.3272 46.6733 41.7329 49.8662C38.4901 53.8573 39.0722 56.7675 39.1553 57.8485C39.2219 58.7132 41.7884 62.089 43.0633 63.6688V65.5812V77.8041C43.0633 79.1344 45.6409 79.5502 48.2185 79.3839C50.2806 79.2508 50.1309 77.0557 49.7983 75.9748C49.2995 72.3717 48.285 64.8662 48.2185 63.6688C48.152 62.4715 49.5697 61.6286 50.4456 60.4552Z",
			fill: "#1B1B20"
		})
	]
});
export default SvgUnlock;
